module.exports = fox._r("images/reg-form-bt-bdr.png", __webpack_public_path__ + "_/_/_/common/frame/images/reg-form-bt-bdr.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/reg-form-bt-bdr.png
// module id = 137
// module chunks = 2